var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.55 15.5 3.29-5.245a1 1 0 0 0-.105-1.22l-.55-.615c2.67-3.315 3.465-6.72 2.28-7.905s-4.59-.37-7.905 2.3l-.615-.55a1 1 0 0 0-1.22-.105L.5 5.45a1 1 0 0 0 .085 1.775l2.175 1.09a3.3 3.3 0 0 0-.17 1A3.9 3.9 0 0 0 3.93 12.1a3.9 3.9 0 0 0 2.785 1.34 3.3 3.3 0 0 0 1-.17l1.09 2.175a1 1 0 0 0 1.745.055m-.895-9.155a2.09 2.09 0 1 1 2.95-2.961 2.09 2.09 0 0 1-2.95 2.961"
  })));
};
export default SvgRocket;